import React, { useState } from 'react';
import { ButtonV2, styled } from '@withjoy/joykit';
import { useEventScheduleByEventIdQuery } from '@graphql/generated';
import { EventConfiguration } from '@apps/workspace/Workspace';
import { EventScheduleDay } from './components/EventScheduleDay';
import { ScheduleState } from './types';
import ScheduleEditor from '@shared/components/ScheduleEditor';

type EventScheduleProps = {
  eventConfiguration: EventConfiguration;
};

const ScheduleContainer = styled.div`
  padding: 8px;
`;

const ScrollWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 16px;
  padding-right: 16px;
`;

export const SCHEDULE_TIME_FORMAT = {
  hour: 'numeric', // '2-digit' for leading zero
  minute: '2-digit',
  hourCycle: 'h12',
} as const;

const EventSchedule: React.FC<EventScheduleProps> = ({ eventConfiguration }) => {
  const [view, setView] = useState<ScheduleState>('view');
  const [editItemId, setEditItemId] = useState<string | null>(null);
  const { eventId } = eventConfiguration;
  const { data, loading } = useEventScheduleByEventIdQuery({
    variables: { eventId: eventId },
    batchMode: 'fast',
  });

  if (view === 'add' || (view === 'edit' && editItemId !== null)) {
    return (
      <ScrollWrapper>
        <ScheduleContainer
          onClick={event => {
            event.stopPropagation();
          }}
        >
          <ScheduleEditor
            mode={view}
            eventId={eventConfiguration.eventId}
            scheduleItemId={editItemId as string}
            onSuccess={async () => {
              setView('view');
            }}
            onCancel={async () => {
              setView('view');
            }}
            refetch={['EventScheduleByEventId']}
          />
        </ScheduleContainer>
      </ScrollWrapper>
    );
  }

  const scheduleData = data?.getGuestGeneralEventScheduleForEvent;
  return (
    <ScrollWrapper>
      <ScheduleContainer>
        {loading && <div>Loading schedule...</div>}
        {!loading &&
          scheduleData &&
          scheduleData?.formattedSchedules.map(day => {
            return (
              <EventScheduleDay
                key={day.dateISO8601TZ}
                day={day}
                onSelect={event => {
                  setView('edit');
                  setEditItemId(event.id);
                }}
              />
            );
          })}
        <ButtonV2
          onClick={event => {
            event.stopPropagation();
            setView('add');
          }}
        >
          Add Event
        </ButtonV2>
      </ScheduleContainer>
    </ScrollWrapper>
  );
};

export default EventSchedule;
